import { useEffect } from "react";
import { dropDownType } from "../constants";
import moment from "moment";

export const buildChips = (filters, config) => {
    if (!filters || !config) return [];

    return Object.keys(filters)
        // .filter((key) => filters[key]) // only non-empty filters
        .filter(key => {
        const val = filters[key];
        if (val == null) return false;
        if (Array.isArray(val)) return val.length > 0;
        if (typeof val === "string") return val !== "";
        if (typeof val === "object")
            return Object.values(val).some(Boolean);
        return true;
        })
        .map((key) => {
            const field = config[key];
            if (!field) return null;

            

            let labelValue = filters[key];
            if (Array.isArray(filters[key])) {
                labelValue = filters[key]
                .map(v => field.options?.[v] || v)
                .join(", ");
            }

            // Handle "select"
            if (field.type === dropDownType.object && field.options) {
                // labelValue = field.options[filters[key]] || filters[key];
                if (Array.isArray(filters[key])) {
                    labelValue = filters[key]
                    .map(v => field.options[v] || v)
                    .join(", ");
                } else {
                    labelValue = field.options[filters[key]] || filters[key];
                }
            }

            // Handle "year"
            if (field.type === "year") {
                const options = field.options || [];

                const getLabel =
                    field.getLabel || ((year) => year);

                const getValue =
                    field.getValue || ((year) => year.split("-")[0]);

                const selected = options.find((opt) => getValue(opt) === filters[key]);

                labelValue = selected ? getLabel(selected) : filters[key];
            }

            //Handle Date
                if (field.type === "DATE") {
            const { fromDate, toDate } = filters[key] || {};

            if (!fromDate && !toDate) return null;

            let labelValue = "";

            if (fromDate && toDate) {
            labelValue = `${moment(fromDate).format("DD-MM-YYYY")} → ${moment(
                toDate
            ).format("DD-MM-YYYY")}`;
            } else if (fromDate) {
            labelValue = `From ${moment(fromDate).format("DD-MM-YYYY")}`;
            } else if (toDate) {
            labelValue = `Upto ${moment(toDate).format("DD-MM-YYYY")}`;
            }

            return {
            key,
            label: `${field.label}: ${labelValue}`,
            };
            }

            // Final chip label
            return {
                key,
                label: `${field.label}: ${labelValue}`,
            };
        })
        .filter(Boolean);
};
